'use client'

import type { ReactNode } from 'react'
import { PanelsSurfaceProvider, type PanelsSkin, type PanelsSurface } from '@/deskUiSkeletons/Page/PanelsSurfaceContext'
import { MoreLink } from '@/deskUiSkeletons/Shared/Shared'
import { mainTemplateVariant, menuTemplateVariant } from '../rowTemplates/RowTemplateConfig'
import { PooCheckedsInfo, PooFoldSubsButton, PooPagingBar, PooRefreshSubs } from './PooControls'

// The PoO Answers panel deliberately keeps the established std geometry.
// Its row template is copied into this surface, so no visual slot imports std.
const pooPanelsSkin: PanelsSkin = {
  toolbar: 'clear-both block min-h-4',
  toolbarHide: 'float-left mb-0.5 flex cursor-pointer items-center bg-green-700 p-0.5 text-[10px] text-white',
  toolbarMessage: 'my-[5px] mb-0.5 ml-[15px] hidden cursor-pointer px-1.5 py-0.5 text-[10px] text-black',
  panelAnswers: 'relative mb-[3px] flex flex-col bg-white pb-0 pl-[5px] pr-[3px] pt-[5px]',
  panelSubmsges: 'relative flex flex-col bg-white pb-10 pl-[5px] pr-[3px] pt-[5px]',
  panelTools: 'float-left flex min-h-4 items-start',
  rootList: 'clear-both mb-[7px] mt-0 flex list-none flex-col p-0 text-[13px] font-[Arial,Tahoma,Verdana,sans-serif]',
  sectionInfo: 'float-left mr-[5px] mb-0.5 flex items-center bg-green-700 p-0.5 text-[10px] text-white',
  sectionInfoCount: 'ml-0.5',
  menuPanel: 'relative flex-col bg-white pb-0 pl-[5px] pr-[3px] pt-[5px]',
  menuPanelShown: '!flex',
  menuPanelHidden: '!hidden',
  togglePhoto: 'ml-1 mr-[5px] flex h-[17px] w-[30px] flex-[0_0_30px] cursor-pointer bg-[#ddd]',
  menuPanelTools: 'flex min-h-4 flex-[0_0_auto] items-start',
  menuList: 'mb-[7px] mt-0 flex list-none flex-col p-0 text-[13px] font-[Arial,Tahoma,Verdana,sans-serif]',
  sectionSwitch: 'flex w-max gap-1 rounded-md bg-slate-100 p-1 text-[12px]',
  sectionSwitchButton: 'rounded px-3 py-1',
  sectionSwitchButtonActive: 'bg-[#3472a9] text-white',
  sectionSwitchButtonInactive: 'bg-white text-[#3472a9]',
  menuEmpty: 'px-[5px] py-3 text-[13px] text-[#94a3b8]',
}

const pooPanelsSurface: PanelsSurface = {
  FoldSubsButton: PooFoldSubsButton,
  PagingBar: PooPagingBar,
  RefreshSubs: PooRefreshSubs,
  CheckedsInfo: PooCheckedsInfo,
  MoreLink,
  menuEmptyLabel: 'No items',
  config: { mainTemplateVariant, menuTemplateVariant },
  skin: pooPanelsSkin,
}

export function PooPanelsSurfaceProvider({ children }: { children: ReactNode }) {
  return <PanelsSurfaceProvider value={pooPanelsSurface}>{children}</PanelsSurfaceProvider>
}
